import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { CreatePlaylist, Playlist, PlaylistListResponse, UpdatePlaylist } from '@frontend/playlist/types';

export class PlaylistClient extends APIClient {
    public static readonly endpoint = '/spot-api/v1';

    public static async fetchPlaylists(queryParams?: ApiQueryParams<DefaultQueryParams>): Promise<PlaylistListResponse> {
        return await this.apiPaginated<PlaylistListResponse, DefaultQueryParams>(`${this.endpoint}/playlists`, queryParams);
    }

    public static async resolvePlaylists(ids: string[], field: string = 'id'): Promise<PlaylistListResponse> {
        return this.resolve<PlaylistListResponse>(`${this.endpoint}/playlists`, ids, field);
    }

    public static async deletePlaylists(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/playlists-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async fetchAccountPlaylists(accountId: string, queryParams?: ApiQueryParams<DefaultQueryParams>): Promise<PlaylistListResponse> {
        return await this.apiPaginated<PlaylistListResponse, DefaultQueryParams>(`${this.endpoint}/accounts/${accountId}/playlists`, queryParams);
    }

    public static async postPlaylist(accountId: string, body: CreatePlaylist): Promise<Playlist> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/playlists`, body);
        return await this.handleResponse<Playlist>(response);
    }

    public static async fetchAccountPlaylist(accountId: string, playlistId: string): Promise<Playlist> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/playlists/${playlistId}`);
        return await this.handleResponse<Playlist>(response);
    }

    public static async patchPlaylist(accountId: string, playlistId: string, body: UpdatePlaylist): Promise<Playlist> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/playlists/${playlistId}`, body);
        return await this.handleResponse<Playlist>(response);
    }

    public static async deletePlaylist(accountId: string, playlistId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/playlists/${playlistId}`);
        return await this.handleVoidResponse(response);
    }

    public static async postIoTSeed(accountId: string, iotId: string, body: { account_id: string }): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/iots/${iotId}/seed`, body);
        return this.handleResponse(response);
    }
}
